import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/contexts/LanguageContext";

type Props = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  placeholder?: string;
};

const SearchBarSection = ({ searchTerm, setSearchTerm, placeholder }: Props) => {
  const { language } = useLanguage();

  return (
    <div className="relative max-w-2xl mx-auto">
      <label htmlFor="blog-search" className="sr-only">
        {language === "ar" ? "البحث في المقالات" : "Search articles"}
      </label>
      <Search aria-hidden="true" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
      <Input
        id="blog-search"
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={placeholder}
        className="pl-10 pr-4 py-3 text-lg border-2 border-gray-200 dark:border-gray-700 rounded-lg focus:border-nexus-teal"
        dir={language === "ar" ? "rtl" : "ltr"}
      />
    </div>
  );
};

export default SearchBarSection;
